import React from 'react'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import DebouncedInput from '../../debounced_input'
import Select from '../../select'
import SearchSecondaryEducationNames from '../../search/secondary_education_names'
import SearchTertiaryEducationNames from '../../search/tertiary_education_names'
import store from '../../../state/store'

class EditEnquiryLearner extends React.Component {

  onDone = () => {
    this.props.onDone()
  }

  onFirstNameChange = (value) => {
    store.emit('enquiry:learners:update', this.props.enquiry_id, this.props.learner_id, {first_name: value})
  }

  onLastNameChange = (value) => {
    store.emit('enquiry:learners:update', this.props.enquiry_id, this.props.learner_id, {last_name: value})
  }

  onGenderChange = (value) =>
    store.emit('enquiry:learners:update', this.props.enquiry_id, this.props.learner_id, {gender: value})

  onLearnerLevelChange = (value) => {
    store.emit('enquiry:learners:update', this.props.enquiry_id, this.props.learner_id, {learner_level: value})
  }

  onSecondaryEducationChange = (value) => {
    store.emit('enquiry:learners:update', this.props.enquiry_id, this.props.learner_id, {high_school: value})
  }

  onTertiaryEducationChange = (value) => {
    store.emit('enquiry:learners:update', this.props.enquiry_id, this.props.learner_id, {tertiary_education: value})
  }

  onEmailAddressChange = (value) => {
    store.emit('enquiry:learners:update', this.props.enquiry_id, this.props.learner_id, {email_address: value})
  }

  onMobileNumberChange = (value) => {
    store.emit('enquiry:learners:update', this.props.enquiry_id, this.props.learner_id, {mobile_number: value})
  }

  render() {
    const genderOptions = [
      ['female','Female'],
      ['male','Male']
    ]
    const isExisting = !!this.props.is_existing

    return (
      <div className="grid gap-4">
        <div className="rounded-[10px] border border-info/30 bg-info/10 px-4 py-3 text-sm">
          {isExisting ? "Editing customer profile's learner." : "Editing learner's enquiry information."}
        </div>
        <div className="grid gap-2">
          <Label>First Name</Label>
          <DebouncedInput value={this.props.first_name} placeholder="First Name" onChange={this.onFirstNameChange}/>
        </div>
        <div className="grid gap-2">
          <Label>Last Name</Label>
          <DebouncedInput value={this.props.last_name} placeholder="Last Name" onChange={this.onLastNameChange}/>
        </div>
        <div className="grid gap-2">
          <Label>Gender</Label>
          <Select options={genderOptions} value={this.props.gender || undefined} onChange={this.onGenderChange}/>
        </div>
        <div className="grid gap-2">
          <Label>Level</Label>
          <DebouncedInput value={this.props.learner_level} placeholder="e.g. Grade 11 / First Year" onChange={this.onLearnerLevelChange}/>
        </div>
        <div className="grid gap-2">
          <Label>Highschool</Label>
          <SearchSecondaryEducationNames value={this.props.high_school} placeholder="High School" onChange={this.onSecondaryEducationChange} onSelect={this.onSecondaryEducationChange}/>
        </div>
        <div className="grid gap-2">
          <Label>Tertiary Education</Label>
          <SearchTertiaryEducationNames value={this.props.tertiary_education} placeholder="Tertiary Education" onChange={this.onTertiaryEducationChange} onSelect={this.onTertiaryEducationChange}/>
        </div>
        <div className="grid gap-2">
          <Label>Email</Label>
          <DebouncedInput value={this.props.email_address} placeholder="Email" type="email" onChange={this.onEmailAddressChange}/>
        </div>
        <div className="grid gap-2">
          <Label>Phone</Label>
          <DebouncedInput value={this.props.mobile_number} placeholder="e.g. +27821234567" regex={/^\+?(\d)*$/} onChange={this.onMobileNumberChange}/>
        </div>
        <div className="flex justify-end gap-2">
          <Button size="sm" onClick={this.onDone}>Done</Button>
        </div>
      </div>
    )
  }
}

export default EditEnquiryLearner
